import { render, staticRenderFns } from "./ObservationsCharts.vue?vue&type=template&id=1df01aa7&"
import script from "./ObservationsCharts.vue?vue&type=script&lang=js&"
export * from "./ObservationsCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports